<template>
<div class="headerBG">
    <NavBar/>


    <b-container>
        <b-row>
            <b-col cols="12">
                <br><br><br><br>
                <img class="imgfull" src="../../assets/logo2.png" alt="">
                <br>
                <br>
                <br><br>
                <h4 class="bottomText">Owning one of our Vanilla NFTs means that you will<br> have a share in the profit and earn a yearly passive income.</h4>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import NavBar from '../Navigation/NavBar.vue'
export default {
    components:{
        NavBar
    }
}
</script>

<style scoped>
.headerBG
{
    background: url('../../assets/header2.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.imgfull
{
    width: 100%;
}
.bottomText
{
    margin-bottom: 5vh;
    margin-top: 35vh;
    color: #266ea5;
    font-size: 3vh;
    font-weight: 600;
    line-height: 5vh;
}

</style>


// WEBPACK FOOTER //
// src/components/Mobile/Header.vue